// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-move[data-v-03255508]{transition:all .5s}.fade-enter-active[data-v-03255508]{animation-name:fadeEnter-03255508;animation-duration:.4s;animation-iteration-count:1}.fade-leave-active[data-v-03255508]{animation-name:fadeLeave-03255508;animation-duration:.2s;animation-iteration-count:1;position:absolute}@keyframes fadeEnter-03255508{0%{opacity:0}to{opacity:1}}@keyframes fadeLeave-03255508{0%{opacity:1}to{opacity:0}}", ""]);
// Exports
module.exports = exports;
